(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('FormulaController', FormulaController);

    FormulaController.$inject = ['$scope', '$state', 'FormulaService', 'ParseLinks', 'AlertService', 'ToastrService', 'SingleDblClickService', 'pagingParams', 'paginationConstants'];

    function FormulaController ($scope, $state, FormulaService, ParseLinks, AlertService, ToastrService, SingleDblClickService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.loadAll = loadAll;
        vm.page = 0;

        vm.gridOptions = {
            paginationPageSizes: [10, 25, 50, 75, 100],
            paginationPageSize: 100,
            enableFiltering: true,
            enableGridMenu: true,
            enableRowSelection: false,
            enableSelectAll: false,
            useExternalPagination: true,
            rowTemplate: SingleDblClickService.rowTemplate(),
            onRegisterApi: function (gridApi) {
                gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                    vm.page = newPage - 1;
                    loadAll();
                });
                gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
                    if (sortColumns && sortColumns.length > 0 && sortColumns[0]) {
                        vm.predicate = sortColumns[0].field;
                        vm.reverse = sortColumns[0].sort.direction === 'asc';
                    } else {
                        vm.predicate = 'id';
                        vm.reverse = true;
                    }
                    loadAll();
                });
                $scope.gridApi = gridApi;
            },
            enableColumnResizing: true,
            columnDefs: [
                {name: 'Label', field: 'label', visible: true},
                {name: 'Type', field: 'type', visible: true},
                {name: 'Rate', field: 'rate', visible: true},
                {name: 'Parent Unit', field: 'parentString', visible: true},
                {name: 'Parent Growth', field: 'parentGrowth.location', visible: true},
                {name: 'Result Unit', field: 'resultString', visible: true},
                {name: 'Result Growth', field: 'resultGrowth.location', visible: true}
            ]
        };

        loadAll();

        function loadAll () {
            FormulaService.query({
                page: vm.page,
                size: vm.gridOptions.paginationPageSize,
                active: true,
                sort: sort()
            }, onSuccess, onError );
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.formulas = data;
                vm.gridOptions.data = vm.formulas;
                vm.gridOptions.totalItems = headers('X-Total-Count');
                // ToastrService.success("Successfully fetched formulas", "Success!");
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            });
        }

        $scope.rowSingleClick = function(row) {
            SingleDblClickService.singleClick(row, 'formula-detail', 'formula');
        };
        $scope.rowDblClick = function(row) {
            $state.go( 'formula.edit', { "id": row.entity.id } );
        };

        vm.createTab = function(data) {
            $scope.$emit('handleEmit', data);
        };
    }
})();
